<template>
  <b-container>
    <b-row class="onas">
      <b-col>
        <div class="animated wow fadeIn">
          <h3>O firmie</h3>
          <h5 class="text-primary">
            Początki firmy sięgają 1990 roku. Po dwuletniej działalności w branży poligraficzno-reklamowej zajęliśmy się konstruowaniem i produkcją nacinarek. 
          </h5>
          <p>Rozwiązania konstrukcyjne nacinarek były całkowicie oryginalne i zostały opatentowane w 1994 roku pod nr. 55585. Jako pierwsi zastosowaliśmy ostrza krążkowe na dużą skalę i to z najwyższej jakości stali.
  Nasze urządzenia użytkują między innymi drukarnie, zakłady poligraficzne, introligatornie, producenci zapałek, tapet i inni.
  Na rynku znajduje się bardzo wiele tych urządzeń.</p>
        </div>
        <b-button to="/kontakt#mapka" variant="primary" class="text-uppercase animated wow bounceIn" data-wow-delay="1s">Kontakt</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Onas',
  components: {},
  methods: {},
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/functions';
@import 'node_modules/bootstrap/scss/variables';

h3 {
  font-size: 60px;
  font-weight: bold;
  text-align: left;
  color: #777;
  margin-bottom: 20px;
  margin-top: 15px;
  text-transform: uppercase;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    font-size: 36px;
  }
}

p {
  font-size: 22px;
  color: #777;
  line-height: 24px;
  text-align: justify;
}
h5 {
  font-size: 26px;
  font-weight: 500;
  margin-bottom: 25px;
  line-height: 28px;
}
.btn {
  margin-top: 30px;
}
.onas {
  padding: 80px 0 100px;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    padding: 50px 0 70px;
  }
}
</style>
